import { CSSProperties } from "react";
import { motion } from "framer-motion";
import { cn } from "src/lib/cn";

interface ImageShimmerOverlayProps {
  delaySeconds?: number;
  className?: string;
}

export default function ImageShimmerOverlay({ delaySeconds = 0, className }: ImageShimmerOverlayProps) {
  return (
    <motion.div
      className={cn("absolute inset-0 bg-[linear-gradient(100deg,transparent_30%,rgba(255,255,255,0.9)_48%,transparent_66%)] bg-[length:220%_100%] bg-no-repeat", className)}
      style={{ opacity: "var(--shimmer-opacity)", mixBlendMode: "var(--shimmer-blend-mode)" as CSSProperties["mixBlendMode"] }}
      animate={{ backgroundPosition: ["140% 0%", "-140% 0%"] }}
      transition={{ duration: 1.6, repeat: Infinity, ease: [0.37, 0, 0.63, 1], delay: delaySeconds }}
      aria-hidden="true"
    />
  );
}
